
<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
       {{ isEdit ? 'Update Link' : 'Create Link' }}
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/link-list">Link Management</router-link></li>
        <li class="active">{{ isEdit ? 'Update' : 'Create' }}</li>
      </ol>
    </section>

    <section class="content">
        <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">

                <!-- Tabs (only show when creating, not editing) -->
                <ul v-if="!isEdit" class="nav nav-tabs link-tabs">
                  <li :class="{ active: activeTab === 'shortlink' }">
                    <a href="#" @click.prevent="activeTab = 'shortlink'">Nivi Short Link</a>
                  </li>
                  <li :class="{ active: activeTab === 'messaging' }">
                    <a href="#" @click.prevent="activeTab = 'messaging'">Messaging Link Generator</a>
                  </li>
                </ul>

                <!-- Tab: Nivi Short Link (or Edit mode) -->
                <div v-if="activeTab === 'shortlink' || isEdit" class="tab-content-area">
                <form @submit.prevent="addOrUpdateOrDeleteLink" action="#"  method="post">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Link Configuration</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="name" class="required">Link Name</label>
                            <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.name.required }" v-model="gRowObj.name" class="form-control" id="name" placeholder="Insert Name"  />
                            <span v-if="submitted && !$v.gRowObj.name.required" class="text-red pull-right">Please enter link name.</span>
                          </div>
                        </div>
                      </div>

                       <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                           <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="long_url" class="required">Destination</label>
                           <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.long_url.required }" v-model="gRowObj.long_url" class="form-control" id="long_url" placeholder="Insert Long Url"  />
                            <span v-if="submitted && !$v.gRowObj.long_url.required" class="text-red pull-right">Please enter url.</span>
                            <span v-if="submitted && !$v.gRowObj.long_url.url" class="text-red pull-right">Please enter valid long url.</span>
                          </div>
                        </div>
                      </div>

                       <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="Client" class="required">Customer</label>
                              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.client_id.required }"
                              id="Client" v-model="gRowObj.client_id">
                                <option value="">--Choose a Option--</option>
                                <option v-for="data in clientList"
                                :selected="data.id === gRowObj.client_id" :key="data.id" :value="data.id">{{data.name}}</option>
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.client_id.required" class="text-red pull-right">Please choose an client.</span>
                            </div>
                        </div>
                      </div>

                       <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="Topic">Topic</label>
                              <nv-select class="form-control"
                              id="Topic" v-model="gRowObj.topic_id">
                                <option value="">--Choose a Option--</option>
                                <option v-for="data in topicList"
                                :selected="data.id === gRowObj.topic_id" :key="data.id" :value="data.id">{{data.display_name}}</option>
                              </nv-select>
                              <!-- <span v-if="submitted && !$v.gRowObj.topic_id.required" class="text-red pull-right">Please choose an topic.</span> -->
                            </div>
                        </div>
                      </div>

                       <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                             <label class="radio-inline">
                              <input v-model="gRowObj.link_type" type="radio" value="auto" name="auto" @change="changeLinkType('auto')"  >Generate URL
                            </label>
                            <label class="radio-inline">
                              <input v-model="gRowObj.link_type" type="radio" value="manual" name="manual" @change="changeLinkType('manual')"  >I want to create a vanity URL
                            </label>
                            </div>
                        </div>
                      </div>

                       <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-12 col-sm-12 col-md-12">
                              <div class="form-group form-inline" v-if="gRowObj.link_type === 'auto'">
                                <a href="javascript:void(0)">{{gRowObj.domain_name}}{{gRowObj.code}}</a>
                                &nbsp; <button class="btn btn-primary btn-sm" :disabled="!(gRowObj.code && gRowObj.code.trim())" @click="checkLinkAvailability">Check Link Value</button>
                                &nbsp;<input type="button" class="btn btn-primary btn-sm" @click="copyLink()" value="Copy Link">
                                &nbsp;<button type="button" class="btn btn-default btn-sm" :disabled="!(gRowObj.code && gRowObj.code.trim())" @click="toggleShortLinkQr"><i class="fa fa-qrcode"></i> {{ showShortLinkQr ? 'Hide' : 'Show' }} QR</button>
                              </div>
                               <div class="form-group form-inline" v-if="gRowObj.link_type === 'manual'">
                                <a href="javascript:void(0)">{{gRowObj.domain_name}}</a> &nbsp;
                                <span style="display: inline-grid; text-align: end;">
                                  <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.code.required }" v-model="gRowObj.code" class="form-control required" id="code" placeholder="Insert text"  />
                                  <span v-if="submitted && !$v.gRowObj.code.required" class="text-red pull-right">Please enter text.</span>
                                  <span v-if="submitted && !$v.gRowObj.code.codeUrlValidationRegex" class="text-red pull-right">Please enter a valid URL</span>
                                </span>
                                &nbsp;<button class="btn btn-primary btn-sm" :disabled="!(gRowObj.code && gRowObj.code.trim())" @click="checkLinkAvailability">Check Link Value</button>
                                &nbsp;<input type="button" class="btn btn-primary btn-sm" @click="copyLink()" value="Copy Link">
                                &nbsp;<button type="button" class="btn btn-default btn-sm" :disabled="!(gRowObj.code && gRowObj.code.trim())" @click="toggleShortLinkQr"><i class="fa fa-qrcode"></i> {{ showShortLinkQr ? 'Hide' : 'Show' }} QR</button>
                              </div>
                              <!-- QR Code Preview for Short Link -->
                              <div v-if="showShortLinkQr" class="shortlink-qr-section">
                                <div class="shortlink-qr-container">
                                  <div class="shortlink-qr-header">QR Code Preview</div>
                                  <img v-if="shortLinkQrPreview" :src="shortLinkQrPreview" alt="QR Code" class="shortlink-qr-image" />
                                  <div class="shortlink-qr-link">{{gRowObj.domain_name}}{{gRowObj.code}}</div>
                                  <button type="button" class="btn btn-primary btn-sm" @click="downloadShortLinkQr">
                                    <i class="fa fa-download"></i> Download QR (1024 x 1024)
                                  </button>
                                </div>
                              </div>
                            </div>
                        </div>
                      </div>



                  </div>
                </div>

                  <div class="row">
                  </div>
                  <div class="row">
                    <div class="action-button">
                      <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                      <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
                    </div>
                  </div>
                </form>
                </div>

                <!-- Tab: Messaging Link Generator -->
                <div v-if="activeTab === 'messaging' && !isEdit" class="tab-content-area">
                  <MessagingLinkGenerator />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import { required, url, helpers } from 'vuelidate/lib/validators'
  import api from '../../../utils/api'
  import { domain } from './../../../config/constants'
  import MessagingLinkGenerator from './MessagingLinkGenerator.vue'
  import QRCode from 'qrcode'
  // import _ from 'lodash'
  const codeUrlValidationRegex = helpers.regex('alpha', /^[-a-zA-Z0-9_()@:%_\\+.,~#?&//=]*$/)
  export default {
    name: 'modal',
    components: {
      MessagingLinkGenerator
    },
    validations: {
      gRowObj: {
        client_id: { required },
        // topic_id: { required },
        name: { required },
        long_url: { required, url },
        code: { required, codeUrlValidationRegex },
        link_type: { required }
      }
    },
    computed: {
      shortLinkFullUrl () {
        return `${this.gRowObj.domain_name}${this.gRowObj.code}`
      }
    },
    watch: {
      shortLinkFullUrl: {
        async handler (newUrl) {
          if (!this.showShortLinkQr || !this.gRowObj.code) return
          try {
            this.shortLinkQrPreview = await QRCode.toDataURL(newUrl, {
              errorCorrectionLevel: 'H',
              margin: 1,
              width: 256
            })
            this.shortLinkQrDownload = await QRCode.toDataURL(newUrl, {
              errorCorrectionLevel: 'H',
              margin: 1,
              width: 1024
            })
          } catch (err) {
            console.error('QR regeneration failed', err)
          }
        }
      }
    },
    data () {
      return {
        clickUrlDomain: '',
        loading: false,
        isEdit: false,
        activeTab: 'shortlink',
        clientList: [],
        topicList: [],
        // isValidUri: true,
        gRowObj: {
          id: null,
          name: '',
          long_url: '',
          client_id: '',
          topic_id: '',
          code: '',
          link_type: '',
          domain_name: ''
        },
        submitted: false,
        actionToBePerformed: 'Add Link',
        showShortLinkQr: false,
        shortLinkQrPreview: '',
        shortLinkQrDownload: ''
      }
    },
    methods: {
      copyLink () {
        var node = document.createElement('textarea')
        node.innerHTML = `${this.gRowObj.domain_name}${this.gRowObj.code}`
        document.body.appendChild(node)
        node.select()
        try {
          var success = document.execCommand('copy')
          success ? this.$swal({
            type: 'success',
            title: 'Link Copied to clipboard!',
            showConfirmButton: false,
            timer: 1000
          }) : null
          success ? console.log('copy successful') : console.log('copy unsuccessful')
        } catch (e) {
          console.log('browser not compatible')
        }
        document.body.removeChild(node)
      },
      async toggleShortLinkQr () {
        if (this.showShortLinkQr) {
          this.showShortLinkQr = false
          return
        }
        const linkUrl = `${this.gRowObj.domain_name}${this.gRowObj.code}`
        if (!linkUrl || !this.gRowObj.code) return
        try {
          this.shortLinkQrPreview = await QRCode.toDataURL(linkUrl, {
            errorCorrectionLevel: 'H',
            margin: 1,
            width: 256
          })
          this.shortLinkQrDownload = await QRCode.toDataURL(linkUrl, {
            errorCorrectionLevel: 'H',
            margin: 1,
            width: 1024
          })
          this.showShortLinkQr = true
        } catch (err) {
          console.error('QR generation failed', err)
        }
      },
      downloadShortLinkQr () {
        if (!this.shortLinkQrDownload) return
        const link = document.createElement('a')
        link.download = `qr-${this.gRowObj.code || 'link'}.png`
        link.href = this.shortLinkQrDownload
        link.click()
      },
      randomString () {
        let len = 6
        let text = ''
        let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for (let i = 0; i < len; i++) {
          text += chars.charAt(Math.floor(Math.random() * chars.length))
        }
        // return text.toUpperCase()
        return text
      },
      changeLinkType (type) {
        this.showShortLinkQr = false
        this.shortLinkQrPreview = ''
        this.shortLinkQrDownload = ''
        this.gRowObj.code = ''
        if (type === 'auto') {
          this.gRowObj.code = this.randomString()
        } else if (type === 'manual') {
          this.gRowObj.code = ''
        }
      },
      close () {
        // console.log('closing the modal')
        this.submitted = false
        this.$router.replace('link-list')
      },
      async addOrUpdateOrDeleteLink (e) {
        console.log('inside addOrUpdateOrDeleteLink function')
        console.log(this.actionToBePerformed)
        console.log(this.gRowObj)
        this.submitted = true
        console.log(this.$v.gRowObj.$invalid)
        this.$v.gRowObj.$touch()
        if (this.$v.gRowObj.$invalid) {
          return
        }
        await this.addOrUpdateLinks()
        this.submitted = false
      },
      async getClientList () {
        return new Promise(resolve => {
          api.buildRequest('getClientData', 'POST').then(({ data }) => {
            this.clientList = data.payload
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getTopicList () {
        return new Promise(resolve => {
          api.buildRequest('getTopics', 'POST').then(({ data }) => {
            this.topicList = data.payload
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getLinkDetails (id) {
        const param = {
          id: id
        }
        return new Promise(resolve => {
          api.buildRequest('getLinkDetails', 'POST', param).then(async ({ data }) => {
            if (data && data.payload && data.payload) {
              const objRes = data.payload
              console.log(this.gRowObj)
              this.gRowObj.id = objRes.id
              this.gRowObj.name = objRes.name
              this.gRowObj.code = objRes.code
              this.gRowObj.client_id = objRes.client_id || ''
              this.gRowObj.topic_id = objRes.topic_id || ''
              this.gRowObj.link_type = objRes.link_type || 'auto'
              this.gRowObj.long_url = objRes.long_url || ''
              console.log(this.gRowObj)
            }
            this.loading = false
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async checkLinkAvailability (e) {
        e.preventDefault()
        this.loading = true
        var param = this.gRowObj
        return new Promise(resolve => {
          api.buildRequest('checkLinkAvailability', 'POST', param).then(({ data }) => {
            this.$swal({
              title: 'Check URL',
              type: 'success',
              text: 'Link is unique'
            })
            resolve()
            this.loading = false
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Check URL',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async addOrUpdateLinks () {
        this.loading = true
        var param = this.gRowObj
        if (this.gRowObj.id) {
          // -- call edit
          return new Promise(resolve => {
            api.buildRequest('updateLink', 'POST', param).then(({ data }) => {
              if (data.payload) {
                this.gRowObj.oldLinkName = data.payload.name
              }
              this.$swal({
                title: 'Update Link',
                type: 'success',
                text: 'Link updated successfully'
              })
              .then(() => {
                this.$router.push({name: '/link-list'})
              })
              resolve()
              this.loading = false
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                title: 'Update Link',
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        } else {
          // -- call add
          return new Promise(resolve => {
            api.buildRequest('addLink', 'POST', param).then(({ data }) => {
              if (data.payload) {
                this.gRowObj.id = data.payload.id
                this.gRowObj.oldLinkName = data.payload.name
              }
              this.$swal({
                title: 'Add Link',
                type: 'success',
                text: 'Link added successfully'
              })
              .then(() => {
                this.$router.push({name: '/link-list'})
              })
              resolve()
              this.loading = false
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                title: 'Add Link',
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        }
      }
    },
    async mounted () {
      this.gRowObj = {
        id: null,
        name: '',
        long_url: '',
        client_id: '',
        topic_id: '',
        code: this.randomString(),
        link_type: 'auto',
        domain_name: ''
      }
      var domainname = window.location.hostname
      this.gRowObj.domain_name = domain[domainname].clickUrlDomain
      this.loading = true
      await this.getClientList()
      await this.getTopicList()
      this.actionToBePerformed = 'Add Link'
      if (this.$route && this.$route.query && this.$route.query.linkId) {
        console.log('route query')
        console.log(this.$route.query.linkId)
        this.actionToBePerformed = 'Update Link'
        this.isEdit = true
        await this.getLinkDetails(this.$route.query.linkId)
      }
      this.loading = false
    }
  }
</script>
<style>
.link-tabs {
  margin-bottom: 0;
  border-bottom: 2px solid #0D9488;
}

.link-tabs > li > a {
  color: #555;
  font-weight: 500;
  padding: 10px 24px;
  border-radius: 10px 10px 0 0;
  border: 1px solid transparent;
}

.link-tabs > li > a:hover {
  background-color: #f5f5f5;
  border-color: #e0e0e0 #e0e0e0 #0D9488;
}

.link-tabs > li.active > a,
.link-tabs > li.active > a:hover,
.link-tabs > li.active > a:focus {
  color: #0D9488;
  font-weight: 600;
  border: 1px solid #0D9488;
  border-bottom-color: #fff;
  background-color: #fff;
}

.tab-content-area {
  padding: 20px 0;
}

.shortlink-qr-section {
  margin-top: 16px;
  text-align: center;
}

.shortlink-qr-container {
  display: inline-block;
  background: #fff;
  border: 1px solid #e0e6ea;
  border-radius: 10px;
  padding: 24px;
  max-width: 320px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.shortlink-qr-header {
  font-size: 12px;
  font-weight: 600;
  color: #7f8c8d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 14px;
}

.shortlink-qr-image {
  display: block;
  margin: 0 auto 10px;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

.shortlink-qr-link {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 11px;
  color: #95a5a6;
  margin-bottom: 14px;
  word-break: break-all;
}

.margin-left-20px {
  margin-left: 20px;
}
.form-group .padding-15px {
  padding: 0 15px;
}
.padding-botton-15px {
  padding-bottom: 15px;
}
.padding-top-15px {
  padding-top: 15px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.body.modal-mask {
  position:fixed;
  height: 100vh;
  overflow-y: hidden;
}
.modal-header h3 {
  width: 100%;
  margin-top: 0;
  color: black;
}
.modal-body {
  overflow: auto;
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.disable {
  color: #b3b1b1;
}
.v-autocomplete {
  position:relative;
}
.v-autocomplete-input {
  padding:10px 15px;
  height:34px;
}
.v-autocomplete-list {
  width:calc(100% - 30px);
  border:1px solid #d2d6de;
  position:absolute;
  top:58px;
  z-index:111;
  list-style: none;
  padding: 0%;
  max-height: 110%;
  overflow: overlay;
}
.v-autocomplete-list-item {
  width:100%;
  border-bottom:1px solid #d2d6de;
  padding:6px 12px;
  font-size:14px;
  background-color:white;
  cursor:pointer;
}
.v-autocomplete-list-item:last-child {
  width:100%;
  border-bottom:none;
}
.v-autocomplete-list-item:hover {
  background-color: #d2d6de;
}
.msg-table thead, .msg-table tbody{
  display: inline-block;
}
.msg-table thead{
  width: calc(100% - 17px);
}
.msg-table tbody{
  max-height: calc(100vh - 300px);
  overflow: auto;
}
.msg-table th, .msg-table td {
  display: block;
  float: left;
}
.msg-table th:first-child, .msg-table td:first-child{
  width: calc(20% - 53px);
}
.msg-table th:nth-child(2), .msg-table td:nth-child(2), .msg-table th:nth-child(3), .msg-table td:nth-child(3){
  width: 40%;
}
.msg-table th:nth-child(4), .msg-table td:nth-child(4){
  width: 53px;
}
.alert-success{
   background-color:#d4edda !important;
   border-color:#d4edda !important
}
.alert-danger{
   background-color:#f7d7da !important;
   border-color:#f7d7da !important
}
.alert-warning{
   background-color:#fff3cd !important;
   border-color:#fff3cd !important
}
.alert-info{
   background-color:#cce5ff !important;
   border-color:#cce5ff !important
}


</style>



// WEBPACK FOOTER //
// addOrUpdateLink.vue?65c7d3bb